import { SceneManager } from "../common/scene.manager";
import { UtilityService } from "../common/services/utility.service";
import { BuildingHelperService } from "../app-confi/services/building-helper.service";
import { BabylonService } from "../components/BuildingConf/babylon.service";
import { HttpService } from "../common/services/http.service";
import { SnackbarService } from "../common/services/snackbar.service";
import { ExplanationService } from "../common/services/explanation.service";

export class ServiceManager {
    static babylonService: BabylonService;
    static sceneManager: SceneManager;
    static buildingHelperService: BuildingHelperService;
    static utilityService: UtilityService;
    static httpService: HttpService;
    static snackbarService: SnackbarService;
    static explanationService: ExplanationService;

    static initServices(
        babylonService: BabylonService,
        sceneManager: SceneManager,
        buildingHelperService: BuildingHelperService,
        utilityService: UtilityService,
        httpService: HttpService,
        snackbarService?: SnackbarService,
    ) {
        const sm = ServiceManager as any;
        sm.babylonService = babylonService;
        sm.sceneManager = sceneManager;
        sm.buildingHelperService = buildingHelperService;
        sm.utilityService = utilityService;
        sm.httpService = httpService;
        if (snackbarService) {
            sm.snackbarService = snackbarService;
        }
    }
}
